export function setSessionCookie(scope: string, name: string, value: any) {
    let fullName = getCookieName(scope, name);
    document.cookie = fullName + "=" + value + ";path=/";
}
function getCookieName(scope: string, name: string) {
    //ug.st =>  ungapped.sessionthrottle
    return ("ug." + scope + "." + name).replace(" ", "");
}
export function getCookie(scope: string, name: string) {
    let key = getCookieName(scope, name);
    let regex = new RegExp("(?:(?:^|.*;\\s*)" + key + "\\s*\\=\\s*([^;]*).*$)|^.*$");
    var cookie = document.cookie.replace(regex, "$1");
    return cookie;
}
export function deleteAllCookies() {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
}

export function checkCookie(scope: string, name: string) {
    var action = getCookie(scope, name);
    if (action != "") {
        return true;
    } else {
        return false;
    }
}
